import { render, staticRenderFns } from "./KioskConfirmation.vue?vue&type=template&id=2d19591a&scoped=true&"
import script from "./KioskConfirmation.vue?vue&type=script&lang=js&"
export * from "./KioskConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./KioskConfirmation.vue?vue&type=style&index=0&id=2d19591a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d19591a",
  null
  
)

export default component.exports